import {
  CreateMarketProductDto,
  MarketProductDto,
  PatchMarketProductDto,
} from '@careapp-group/ng-sdk';
import { CaEntityActionsFactory } from '../../../store/entity-state/entity-actions-factory';
import { MarketProductFilterType } from './market-management-products.reducer';

class MarketManagementProductsActions extends CaEntityActionsFactory<
  MarketProductDto,
  CreateMarketProductDto,
  PatchMarketProductDto,
  MarketProductFilterType
> {
  constructor() {
    super('MarketManagementProducts');
  }
}

export const MarketManagementProductActions = new MarketManagementProductsActions();
